import SockJS from 'sockjs-client';
import Stomp from 'webstomp-client';
import store from "@/store";

class StompService {

  constructor() {
    this.socket = null;
    this.stompClient = null;
    this.loop = true;
  }

  connect(url) {

    if(store.state.auth.user) {


      return new Promise((resolve, reject) => {
        this.socket = new SockJS(url, null, {withCredentials: true});
        this.stompClient = Stomp.over(this.socket);

        this.stompClient.connect({},
            () => {
              this.onConnect();
              resolve(this.stompClient);
            },
            (error) => {
              this.onError(error);
              if (this.loop) {
                new Promise(res => setTimeout(res, 1000)); // wait 1 second
                this.connect(url);
              }
              reject(error);
            }
        );
      });
    }
  }

  disconnect() {
    this.loop = false;
    if (this.stompClient) {
      this.stompClient.disconnect();
      store.dispatch("stomp/setConnectionStateAction",false)
    }
  }

  subscribe(topic, callback) {
    console.log(topic + " __ " + callback)
    return this.stompClient.subscribe(topic, (message) => {
      console.log(message)
      callback(message.body);
    });
  }

  onError(error) {
    console.log("Server WS-Connection ERROR: ");
    console.log(error);
    store.dispatch("stomp/setConnectionStateAction",false)
    console.log("Reconnecting to Server...")
  }

  onConnect() {
    store.dispatch("stomp/setConnectionStateAction",true)
    console.log("WS to Server established");
  }
}
export default StompService;